/**
 * AUD-CRAWL-K1 (audit d'utilisabilité du 2026-10-09) — UNE lecture des horodatages servis par la
 * passerelle.
 *
 * La passerelle sert deux écritures d'un même instant : l'ISO 8601 (`2026-10-08T07:51:03Z`) et le
 * texte PostgreSQL d'un `timestamptz::text` (`2026-10-08 07:51:03.636293+00`, décalage SANS
 * minutes). Le moteur JavaScript ne garantit que la première : `new Date('2026-10-08T07:51:03.636293+00')`
 * vaut `NaN` (V8, mesuré sous Node 24), et la forme à espace n'est qu'une tolérance propre à chaque
 * moteur. Les lectures locales remplaçaient l'espace par `T` sans compléter le décalage : la date
 * devenait illisible, son instant `+Infinity`, et le bandeau « Prochaine action » disait « en attente
 * depuis 0 min » pour une approbation vieille de 30 h.
 *
 * Règle : la valeur est réécrite en ISO strict (`AAAA-MM-JJTHH:MM:SS.mmm±HH:MM`) avant d'être lue ;
 * sans décalage, l'instant est en UTC (l'heure de la passerelle et de sa base) ; une valeur
 * illisible rend `null` — jamais `NaN` ni l'infini : à l'appelant de dire « inconnu ».
 */

/** Date, heure facultative (fraction de seconde comprise), décalage facultatif (`Z`, `+00`, `+0530`, `+05:30`). */
const FORME = /^(\d{4}-\d{2}-\d{2})(?:[Tt ](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d+))?)?)?\s*(?:([Zz])|([+-])(\d{2})(?::?(\d{2}))?)?$/

/** Millisecondes depuis l'époque Unix, ou `null` si la valeur n'est pas un instant lisible. */
export function lireInstant(valeur: string | null | undefined): number | null {
  const brut = valeur?.trim()
  if (!brut) return null
  const m = FORME.exec(brut)
  if (!m) {
    // Autre écriture (RFC 2822…) : le moteur en décide, sans jamais rendre NaN.
    const t = Date.parse(brut)
    return Number.isNaN(t) ? null : t
  }
  const [, jour, heures = '00', minutes = '00', secondes = '00', fraction = '', zulu, signe, decalageH, decalageM = '00'] = m
  // Les microsecondes de PostgreSQL sont tronquées à la milliseconde, la précision d'une `Date`.
  const millisecondes = `${fraction}000`.slice(0, 3)
  const decalage = zulu || !signe ? 'Z' : `${signe}${decalageH}:${decalageM}`
  const t = Date.parse(`${jour}T${heures}:${minutes}:${secondes}.${millisecondes}${decalage}`)
  return Number.isNaN(t) ? null : t
}
